export default __webpack_public_path__ + "static/media/success.022bc9cc.jpg";